import {
  getThemeId,
  getActionButtonThemeId as amalgamGetActionButtonThemeId,
  getCatalogueTheme as amalgamGetCatalogueTheme,
  getActionButtonTheme as amalgamGetActionButtonTheme
} from './Amalgam';
import {
  getCustomPageHiddenCatalogueActionButtonThemes,
  getCustomPageSectionHiddenCatalogueId
} from './CustomPageAmalgam';

const DEFAULT_THEME = {
  addToCartButton: {
    backgroundImage: 'linear-gradient(-179deg, #738ff6 3%, #4165a4 100%)',
    backgroundImageHover: 'linear-gradient(-179deg, #4d67c1 3%, #5580cd 100%)',
    textColor: '#ffffff',
    border: '1px solid #506FD4',
    backgroundColor: '#506FD4',
    color: '#506FD4'
  },
  inquiryQuantityPicker: {
    backgroundColor: '#4763bf',
    textColor: '#ffffff',
    disabledButtonBackgroundColor: '#544e4e00',
    backgroundImage: 'linear-gradient(-179deg, #738ff6 3%, #4165a4 100%)',
    backgroundImageHover: 'linear-gradient(-179deg, #4d67c1 3%, #5580cd 100%)',
    minusButtonBackgroundColor: '#eaeff7',
    borderTopColor: '1px solid rgb(42, 51, 59)',
    sizeOptionIncrementBackgroundColor: '#f1f3f9'
  },
  banner: {
    backgroundColor: '#171B21',
    textColor: '#ffffff'
  },
  companyTheme: {
    companyNameTextColor: '#ffffff',
    companyLogoError: {
      color: '#000000',
      border: '1px solid #000000',
      boxShadow: '0 2px 8px 0 #000000',
      textShadow: '0 1px #7e7e7e',
      MozBoxShadow: '0 2px 8px 0 #000000',
      backgroundImage: 'linear-gradient(-180deg, #4e5c66 0%, #13171a 100%)',
      webkitBoxShadow: '0 2px 8px 0 #000000'
    }
  },
  homeGrid: {
    gridAddToListClass: 'dark',
    adTile: {
      downloadBackgroundColor: '#1b6bf8',
      downloadTextColor: '#ffffff',
      gradientEnd: '#000000',
      gradientStart: 'transparent',
      poweredByColor: '#adbaca',
      poweredByLinkColor: '#389ef5',
      textColor: '#ffffff'
    },
    addToList: {
      backgroundColor: '#6495ed',
      borderColor: '#89AAFF',
      starColor: '#FFFFFF',
      textColor: '#FFFFFF'
    },
    addToListSuccess: {
      backgroundColor: '#50b681',
      borderColor: '#56be84',
      checkmarkColor: '#ffffff',
      textColor: '#ffffff'
    },
    backgroundColor: '#2A333B',
    bookmarkCard: {
      borderColor: '#FFFFFF',
      buttonBorderColor: 'rgb(58, 61, 230)',
      buttonGradientEnd: 'transparent',
      buttonGradientStart: 'transparent',
      buttonShadowColor: 'rgb(58, 61, 230)',
      buttonTextColor: 'rgb(58, 61, 230)',
      gradientEnd: '#FFFFFF',
      gradientStart: '#FFFFFF',
      shadowColor: 'transparent',
      subtitleColor: 'rgb(58, 61, 230)',
      successColor: '#ABC2B9',
      titleColor: 'rgb(58, 61, 230)'
    },
    chatButtonClass: 'dark',
    clearFilterColor: '#F5D4A6',
    contactCard: {
      borderColor: 'transparent',
      buttonBorderColor: 'rgb(58, 61, 230)',
      buttonGradientEnd: 'transparent',
      buttonGradientStart: 'transparent',
      buttonShadowColor: 'rgb(58, 61, 230)',
      buttonTextColor: 'rgb(58, 61, 230)',
      fieldLabelColor: 'rgb(58, 61, 230)',
      gradientEnd: '#FFFFFF',
      gradientStart: '#FFFFFF',
      inputShadowColor: 'rgba(0,0,0,0.12)',
      shadowColor: 'transparent',
      subtitleColor: 'rgb(58, 61, 230)',
      successColor: '#ABC2B9',
      titleColor: 'rgb(58, 61, 230)'
    },
    headline: {
      backgroundColor: '#2A333B',
      seeMoreColor: '#46b8ff',
      textColor: '#FFFFFF'
    },
    outOfStockBadge: {
      backgroundColor: 'rgba(255, 0, 0, 0.8)',
      textColor: '#ffffff'
    },
    resellButtonClass: 'dark',
    searchClass: 'dark',
    subscribeClass: 'dark',
    tags: {
      backgroundColor: '#2A333B',
      hoverColor: 'rgba(81, 90, 99, 1)',
      textColor: '#ffffff'
    },
    textColor: '#FFFFFF',
    tileBackgroundColor: '#ffffff',
    tileBorder: 'none',
    tileDiscountBackgroundColor: '#3a3de6',
    tileDiscountTextColor: '#FFFFFF',
    tilePictureCountBackgroundColor: '#ffffff',
    tilePictureCountShadowColor: 'rgba(0, 0, 0, 0.1)',
    tilePictureCountTextColor: '#000000',
    tileShadowColor: 'rgba(0, 0, 0, 0.6)',
    tileTextColor: '#2F3D55',
    searchIconColor: '#ffffff',
    companyCardLogoErrorClass: 'dark'
  },
  orderBar: {
    backgroundImage: 'linear-gradient(-179deg, #738ff6 3%, #4165a4 100%)',
    backgroundImageHover: 'linear-gradient(-179deg, #4d67c1 3%, #5580cd 100%)',
    boxShadow: '0 0 10px 4px rgba(0,0,0,0.1)',
    webkitBoxShadow: '0 0 10px 4px rgba(0,0,0,0.1)',
    MozBoxShadow: '0 0 10px 4px rgba(0,0,0,0.1)',
    color: '#ffffff'
  },
  homepage: {
    primaryColor: '#ffffff',
    backgroundColor: 'rgb(31, 38, 43)',
    searchBarBorder: 'solid 1px hsl(0deg 0% 0% / 38%)',
    catalogueBoxShadow: 'rgb(0 0 0 / 30%) 0 0 5px',
    moreCatalogueBoxShadow: 'rgb(0 0 0 / 30%) 0 0 5px',
    headerBottomBorder: '1px solid rgba(0, 0, 0, 0.38)',
    textUnderlineColor: '#ffffff54',
    catalogueTileBorder: 'none',
    productTileBorder: '1px solid rgb(31, 38, 43)',
    moreProductTileBorder: '1px solid rgb(31, 38, 43)',
    catalogueTitleColor: '#dde2e6',
    catalogueItemCountColor: '#dde2e6',
    expandedHeaderBackground: 'rgb(31, 38, 43)',
    searchBarBackgroundColor: 'rgb(0 0 0 / 30%)',
    collapsedHeaderBackground: 'rgb(31, 38, 43)',
    catalogueItemBackground: 'rgb(0 0 0 / 35%)',
    companyAdTileTopBorder: '1px solid #181f23',
    companyAdTileBackgroundColor: 'rgb(31, 38, 43)',
    footerContentTextColor: '#ffffff',
    wLinkBackgroundColor: '#2C333A',
    iconColor: '#ffffff'
  },
  id: 'dark',
  priority: 100,
  name: 'QuickSell Dark',
  reviewPageBackgroundColor: '#F9FBFD',
  themeTextColor: '#6084fb',
  priceTextColor: '#2f5ec6',
  pictureOutlineColor: '#2ebe83',
  discountBarBackgroundColor: '#2f5ec6',
  pageTextColor: '#ffffff',
  tapToSeeMoreColor: '#46b8ff',
  companyTitleTextColor: '#2f3d55',
  footerTextColor: '#ffffff',
  backIconColor: '#000000',
  tagSelectedCountColor: '#ffffff',
  cartButtonBackground: 'linear-gradient(to bottom,#8affd5 0,#52ffab 100%)',
  cartIconsColor: '#000000'
};

const DEFAULT_ACTION_BUTTON_THEME = {
  text: 'ADD TO LIST',
  successText: 'ADDED',
  confirmSelection: 'Confirm selection',
  confirmMultipleSelection: 'Confirm selection',
  confirmSelectionConfirmation: 'Are you sure you want to confirm this order?',
  confirmMultipleSelectionConfirmation: 'Are you sure you want to confirm this order?'
};

const parsedTheme = {};
const parsedActionButtonTheme = {};

const getParsedTheme = rawTheme => {
  const themeId = (rawTheme || {}).id || 'dark';

  if (parsedTheme[themeId]) {
    return parsedTheme[themeId];
  }

  if (!rawTheme) {
    rawTheme = DEFAULT_THEME;
  }

  if (!rawTheme.inquiryQuantityPicker) {
    rawTheme.inquiryQuantityPicker = DEFAULT_THEME.inquiryQuantityPicker;
  }

  if (!rawTheme.addToCartButton) {
    rawTheme.addToCartButton = DEFAULT_THEME.addToCartButton;
  }

  if (!rawTheme.banner) {
    rawTheme.banner = DEFAULT_THEME.banner;
  }

  if (!rawTheme.companyTheme) {
    rawTheme.companyTheme = DEFAULT_THEME.companyTheme;
  }

  if (!rawTheme.orderBar) {
    rawTheme.orderBar = DEFAULT_THEME.orderBar;
  }

  if (!rawTheme.homeGrid) {
    rawTheme.homeGrid = DEFAULT_THEME.homeGrid;
  }

  if (!rawTheme.homeGrid.backgroundColor) {
    rawTheme.homeGrid.backgroundColor = DEFAULT_THEME.homeGrid.backgroundColor;
  }

  if (!rawTheme.homeGrid.textColor) {
    rawTheme.homeGrid.textColor = DEFAULT_THEME.homeGrid.textColor;
  }

  if (!rawTheme.homeGrid.tileBackgroundColor) {
    rawTheme.homeGrid.tileBackgroundColor = DEFAULT_THEME.homeGrid.tileBackgroundColor;
  }

  if (!rawTheme.homeGrid.tileTextColor) {
    rawTheme.homeGrid.tileTextColor = DEFAULT_THEME.homeGrid.tileTextColor;
  }

  if (!rawTheme.homeGrid.tileShadowColor) {
    rawTheme.homeGrid.tileShadowColor = DEFAULT_THEME.homeGrid.tileShadowColor;
  }

  if (!rawTheme.homeGrid.tileDiscountBackgroundColor) {
    rawTheme.homeGrid.tileDiscountBackgroundColor =
      DEFAULT_THEME.homeGrid.tileDiscountBackgroundColor;
  }

  if (!rawTheme.homeGrid.tileDiscountTextColor) {
    rawTheme.homeGrid.tileDiscountTextColor = DEFAULT_THEME.homeGrid.tileDiscountTextColor;
  }

  if (!rawTheme.homeGrid.tilePictureCountBackgroundColor) {
    rawTheme.homeGrid.tilePictureCountBackgroundColor =
      DEFAULT_THEME.homeGrid.tilePictureCountBackgroundColor;
  }

  if (!rawTheme.homeGrid.tilePictureCountTextColor) {
    rawTheme.homeGrid.tilePictureCountTextColor = DEFAULT_THEME.homeGrid.tilePictureCountTextColor;
  }

  if (!rawTheme.homeGrid.tilePictureCountShadowColor) {
    rawTheme.homeGrid.tilePictureCountShadowColor =
      DEFAULT_THEME.homeGrid.tilePictureCountShadowColor;
  }

  if (!rawTheme.homeGrid.tileBorder) {
    rawTheme.homeGrid.tileBorder = DEFAULT_THEME.homeGrid.tileBorder;
  }

  if (!rawTheme.homeGrid.chatButtonClass) {
    rawTheme.homeGrid.chatButtonClass = DEFAULT_THEME.homeGrid.chatButtonClass;
  }

  if (!rawTheme.homeGrid.searchClass) {
    rawTheme.homeGrid.searchClass = DEFAULT_THEME.homeGrid.searchClass;
  }

  if (!rawTheme.homeGrid.subscribeClass) {
    rawTheme.homeGrid.subscribeClass = DEFAULT_THEME.homeGrid.subscribeClass;
  }

  if (!rawTheme.homeGrid.resellButtonClass) {
    rawTheme.homeGrid.resellButtonClass = DEFAULT_THEME.homeGrid.resellButtonClass;
  }

  if (!rawTheme.homeGrid.gridAddToListClass) {
    rawTheme.homeGrid.gridAddToListClass = DEFAULT_THEME.homeGrid.gridAddToListClass;
  }

  if (!rawTheme.homeGrid.addToList) {
    rawTheme.homeGrid.addToList = DEFAULT_THEME.homeGrid.addToList;
  }

  if (!rawTheme.homeGrid.addToList.backgroundColor) {
    rawTheme.homeGrid.addToList.backgroundColor = DEFAULT_THEME.homeGrid.addToList.backgroundColor;
  }

  if (!rawTheme.homeGrid.addToList.borderColor) {
    rawTheme.homeGrid.addToList.borderColor = DEFAULT_THEME.homeGrid.addToList.borderColor;
  }

  if (!rawTheme.homeGrid.addToList.textColor) {
    rawTheme.homeGrid.addToList.textColor = DEFAULT_THEME.homeGrid.addToList.textColor;
  }

  if (!rawTheme.homeGrid.addToList.starColor) {
    rawTheme.homeGrid.addToList.starColor = DEFAULT_THEME.homeGrid.addToList.starColor;
  }

  if (!rawTheme.homeGrid.addToListSuccess) {
    rawTheme.homeGrid.addToListSuccess = DEFAULT_THEME.homeGrid.addToListSuccess;
  }

  if (!rawTheme.homeGrid.addToListSuccess.backgroundColor) {
    rawTheme.homeGrid.addToListSuccess.backgroundColor =
      DEFAULT_THEME.homeGrid.addToListSuccess.backgroundColor;
  }

  if (!rawTheme.homeGrid.addToListSuccess.borderColor) {
    rawTheme.homeGrid.addToListSuccess.borderColor =
      DEFAULT_THEME.homeGrid.addToListSuccess.borderColor;
  }

  if (!rawTheme.homeGrid.addToListSuccess.textColor) {
    rawTheme.homeGrid.addToListSuccess.textColor =
      DEFAULT_THEME.homeGrid.addToListSuccess.textColor;
  }

  if (!rawTheme.homeGrid.tags) {
    rawTheme.homeGrid.tags = DEFAULT_THEME.homeGrid.tags;
  }

  if (!rawTheme.homeGrid.tags.hoverColor) {
    rawTheme.homeGrid.tags.hoverColor = DEFAULT_THEME.homeGrid.tags.hoverColor;
  }

  if (!rawTheme.homeGrid.tags.backgroundColor) {
    rawTheme.homeGrid.tags.backgroundColor = DEFAULT_THEME.homeGrid.tags.backgroundColor;
  }

  if (!rawTheme.homeGrid.tags.textColor) {
    rawTheme.homeGrid.tags.textColor = DEFAULT_THEME.homeGrid.tags.textColor;
  }

  if (!rawTheme.homeGrid.headline) {
    rawTheme.homeGrid.headline = DEFAULT_THEME.homeGrid.headline;
  }

  if (!rawTheme.homeGrid.headline.backgroundColor) {
    rawTheme.homeGrid.headline.backgroundColor = DEFAULT_THEME.homeGrid.headline.backgroundColor;
  }

  if (!rawTheme.homeGrid.headline.textColor) {
    rawTheme.homeGrid.headline.textColor = DEFAULT_THEME.homeGrid.headline.textColor;
  }

  if (!rawTheme.homeGrid.headline.seeMoreColor) {
    rawTheme.homeGrid.headline.seeMoreColor = DEFAULT_THEME.homeGrid.headline.seeMoreColor;
  }

  if (!rawTheme.homeGrid.adTile) {
    rawTheme.homeGrid.adTile = DEFAULT_THEME.homeGrid.adTile;
  }

  if (!rawTheme.homeGrid.adTile.downloadBackgroundColor) {
    rawTheme.homeGrid.adTile.downloadBackgroundColor =
      DEFAULT_THEME.homeGrid.adTile.downloadBackgroundColor;
  }

  if (!rawTheme.homeGrid.adTile.downloadTextColor) {
    rawTheme.homeGrid.adTile.downloadTextColor = DEFAULT_THEME.homeGrid.adTile.downloadTextColor;
  }

  if (!rawTheme.homeGrid.adTile.gradientEnd) {
    rawTheme.homeGrid.adTile.gradientEnd = DEFAULT_THEME.homeGrid.adTile.gradientEnd;
  }

  if (!rawTheme.homeGrid.adTile.gradientStart) {
    rawTheme.homeGrid.adTile.gradientStart = DEFAULT_THEME.homeGrid.adTile.gradientStart;
  }

  if (!rawTheme.homeGrid.adTile.poweredByColor) {
    rawTheme.homeGrid.adTile.poweredByColor = DEFAULT_THEME.homeGrid.adTile.poweredByColor;
  }

  if (!rawTheme.homeGrid.adTile.poweredByLinkColor) {
    rawTheme.homeGrid.adTile.poweredByLinkColor = DEFAULT_THEME.homeGrid.adTile.poweredByLinkColor;
  }

  if (!rawTheme.homeGrid.adTile.textColor) {
    rawTheme.homeGrid.adTile.textColor = DEFAULT_THEME.homeGrid.adTile.textColor;
  }

  if (!rawTheme.homeGrid.bookmarkCard) {
    rawTheme.homeGrid.bookmarkCard = DEFAULT_THEME.homeGrid.bookmarkCard;
  }

  if (!rawTheme.homeGrid.bookmarkCard.buttonGradientEnd) {
    rawTheme.homeGrid.bookmarkCard.buttonGradientEnd =
      DEFAULT_THEME.homeGrid.bookmarkCard.buttonGradientEnd;
  }

  if (!rawTheme.homeGrid.bookmarkCard.buttonGradientStart) {
    rawTheme.homeGrid.bookmarkCard.buttonGradientStart =
      DEFAULT_THEME.homeGrid.bookmarkCard.buttonGradientStart;
  }

  if (!rawTheme.homeGrid.bookmarkCard.buttonShadowColor) {
    rawTheme.homeGrid.bookmarkCard.buttonShadowColor =
      DEFAULT_THEME.homeGrid.bookmarkCard.buttonShadowColor;
  }

  if (!rawTheme.homeGrid.bookmarkCard.buttonTextColor) {
    rawTheme.homeGrid.bookmarkCard.buttonTextColor =
      DEFAULT_THEME.homeGrid.bookmarkCard.buttonTextColor;
  }

  if (!rawTheme.homeGrid.bookmarkCard.gradientEnd) {
    rawTheme.homeGrid.bookmarkCard.gradientEnd = DEFAULT_THEME.homeGrid.bookmarkCard.gradientEnd;
  }

  if (!rawTheme.homeGrid.bookmarkCard.gradientStart) {
    rawTheme.homeGrid.bookmarkCard.gradientStart =
      DEFAULT_THEME.homeGrid.bookmarkCard.gradientStart;
  }

  if (!rawTheme.homeGrid.bookmarkCard.subtitleColor) {
    rawTheme.homeGrid.bookmarkCard.subtitleColor =
      DEFAULT_THEME.homeGrid.bookmarkCard.subtitleColor;
  }

  if (!rawTheme.homeGrid.bookmarkCard.successColor) {
    rawTheme.homeGrid.bookmarkCard.successColor = DEFAULT_THEME.homeGrid.bookmarkCard.successColor;
  }

  if (!rawTheme.homeGrid.bookmarkCard.titleColor) {
    rawTheme.homeGrid.bookmarkCard.titleColor = DEFAULT_THEME.homeGrid.bookmarkCard.titleColor;
  }

  if (!rawTheme.homeGrid.contactCard) {
    rawTheme.homeGrid.contactCard = DEFAULT_THEME.homeGrid.contactCard;
  }

  if (!rawTheme.homeGrid.contactCard.buttonGradientEnd) {
    rawTheme.homeGrid.contactCard.buttonGradientEnd =
      DEFAULT_THEME.homeGrid.contactCard.buttonGradientEnd;
  }

  if (!rawTheme.homeGrid.contactCard.buttonGradientStart) {
    rawTheme.homeGrid.contactCard.buttonGradientStart =
      DEFAULT_THEME.homeGrid.contactCard.buttonGradientStart;
  }

  if (!rawTheme.homeGrid.contactCard.buttonShadowColor) {
    rawTheme.homeGrid.contactCard.buttonShadowColor =
      DEFAULT_THEME.homeGrid.contactCard.buttonShadowColor;
  }

  if (!rawTheme.homeGrid.contactCard.buttonTextColor) {
    rawTheme.homeGrid.contactCard.buttonTextColor =
      DEFAULT_THEME.homeGrid.contactCard.buttonTextColor;
  }

  if (!rawTheme.homeGrid.contactCard.fieldLabelColor) {
    rawTheme.homeGrid.contactCard.fieldLabelColor =
      DEFAULT_THEME.homeGrid.contactCard.fieldLabelColor;
  }

  if (!rawTheme.homeGrid.contactCard.gradientEnd) {
    rawTheme.homeGrid.contactCard.gradientEnd = DEFAULT_THEME.homeGrid.contactCard.gradientEnd;
  }

  if (!rawTheme.homeGrid.contactCard.gradientStart) {
    rawTheme.homeGrid.contactCard.gradientStart = DEFAULT_THEME.homeGrid.contactCard.gradientStart;
  }

  if (!rawTheme.homeGrid.contactCard.inputShadowColor) {
    rawTheme.homeGrid.contactCard.inputShadowColor =
      DEFAULT_THEME.homeGrid.contactCard.inputShadowColor;
  }

  if (!rawTheme.homeGrid.contactCard.subtitleColor) {
    rawTheme.homeGrid.contactCard.subtitleColor = DEFAULT_THEME.homeGrid.contactCard.subtitleColor;
  }

  if (!rawTheme.homeGrid.contactCard.titleColor) {
    rawTheme.homeGrid.contactCard.titleColor = DEFAULT_THEME.homeGrid.contactCard.titleColor;
  }

  if (!rawTheme.homeGrid.outOfStockBadge) {
    rawTheme.homeGrid.outOfStockBadge = DEFAULT_THEME.homeGrid.outOfStockBadge;
  }

  if (!rawTheme.homeGrid.outOfStockBadge.backgroundColor) {
    rawTheme.homeGrid.outOfStockBadge.backgroundColor =
      DEFAULT_THEME.homeGrid.outOfStockBadge.backgroundColor;
  }

  if (!rawTheme.homeGrid.outOfStockBadge.textColor) {
    rawTheme.homeGrid.outOfStockBadge.textColor = DEFAULT_THEME.homeGrid.outOfStockBadge.textColor;
  }

  parsedTheme[themeId] = rawTheme;

  return parsedTheme[themeId];
};
const getParsedActionButtonTheme = rawActionButtonTheme => {
  const themeId = rawActionButtonTheme.id || 'add_to_list';

  if (parsedActionButtonTheme[themeId]) {
    return parsedActionButtonTheme[themeId];
  }

  const actionButtonTheme = {
    text:
      rawActionButtonTheme && rawActionButtonTheme.text
        ? rawActionButtonTheme.text
        : DEFAULT_ACTION_BUTTON_THEME.text,
    successText:
      rawActionButtonTheme && rawActionButtonTheme.successText
        ? rawActionButtonTheme.successText
        : DEFAULT_ACTION_BUTTON_THEME.successText,
    confirmSelection:
      rawActionButtonTheme && rawActionButtonTheme.confirmSelection
        ? rawActionButtonTheme.confirmSelection
        : DEFAULT_ACTION_BUTTON_THEME.confirmSelection,
    confirmMultipleSelection:
      rawActionButtonTheme && rawActionButtonTheme.confirmMultipleSelection
        ? rawActionButtonTheme.confirmMultipleSelection
        : DEFAULT_ACTION_BUTTON_THEME.confirmMultipleSelection,
    confirmSelectionConfirmation:
      rawActionButtonTheme && rawActionButtonTheme.confirmSelectionConfirmation
        ? rawActionButtonTheme.confirmSelectionConfirmation
        : DEFAULT_ACTION_BUTTON_THEME.confirmSelectionConfirmation,
    confirmMultipleSelectionConfirmation:
      rawActionButtonTheme && rawActionButtonTheme.confirmMultipleSelectionConfirmation
        ? rawActionButtonTheme.confirmMultipleSelectionConfirmation
        : DEFAULT_ACTION_BUTTON_THEME.confirmMultipleSelectionConfirmation
  };

  parsedActionButtonTheme[themeId] = actionButtonTheme;

  return parsedActionButtonTheme[themeId];
};

export const getCatalogueThemeId = () => getThemeId();
export const getCatalogueTheme = () => getParsedTheme(amalgamGetCatalogueTheme() || {});
export const getActionButtonThemeId = () => amalgamGetActionButtonThemeId();
export const getActionButtonTheme = () =>
  getParsedActionButtonTheme(amalgamGetActionButtonTheme() || {});
export const getCustomPageHiddenCatalogueActionButtonTheme = sectionId => {
  const hiddenCatalogueId = getCustomPageSectionHiddenCatalogueId(sectionId);
  const actionButtonThemes = getCustomPageHiddenCatalogueActionButtonThemes() || [];
  const actionButtonTheme = actionButtonThemes.find(
    actionButtonTheme => actionButtonTheme.catalogueId === hiddenCatalogueId
  );
  return getParsedActionButtonTheme(actionButtonTheme || {});
};
